import React, { useRef } from "react"
import { Button, Dropdown } from "@mimber/ui-web"
import { MoreOutlined, EditOutlined, DeleteOutlined } from "@mimber/ui-web"
import { usePermissionedMenuItems } from "@/core/hooks/usePermissionedMenuItems"
import { EditTaxRateModal } from "@/components/modals/EditTaxRateModal"
import { useDeleteTaxRateModal } from "@/components/modals/DeleteTaxRateModal"
import { Resource, Action } from "@mimber/schema"
import type { PermissionedMenuItem } from "@/core/hooks/usePermissionedMenuItems"
import type { TaxRateActionsDropdownProps } from "./TaxRateActionsDropdown.types"

export const TaxRateActionsDropdown: React.FunctionComponent<
  TaxRateActionsDropdownProps
> = ({
  taxRate,
  onActionComplete,
  size = "small",
  type = "text",
  iconOnly = true,
}) => {
  const openEditRef = useRef<(() => void) | null>(null)

  const { contextHolder, showDeleteTaxRateModal } =
    useDeleteTaxRateModal(onActionComplete)

  const menuItems: PermissionedMenuItem[] = [
    {
      key: "edit",
      label: "Edit Rate",
      icon: <EditOutlined />,
      resource: Resource.ORGANIZATION,
      action: Action.UPDATE,
      onClick: () => openEditRef.current?.(),
    },
    {
      key: "delete",
      label: "Delete Rate",
      icon: <DeleteOutlined />,
      danger: true,
      resource: Resource.ORGANIZATION,
      action: Action.DELETE,
      onClick: () => showDeleteTaxRateModal(taxRate),
    },
  ]

  const { items } = usePermissionedMenuItems({ items: menuItems })

  return (
    <>
      {contextHolder}
      <EditTaxRateModal
        taxRate={taxRate}
        onSuccess={onActionComplete}
        renderButton={(open) => {
          openEditRef.current = open
          return <></>
        }}
      />
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Button
          type={type}
          icon={iconOnly ? <MoreOutlined /> : undefined}
          size={size}
        >
          {!iconOnly && "Actions"}
        </Button>
      </Dropdown>
    </>
  )
}
